import React, { useState, useEffect, useContext, useMemo } from 'react';


import SimpleTable from '../../../components/tables/simpleTable';

import RecoverModal from '../../../components/modals/recoverModal';
import DeleteModal from '../../../components/modals/deleteModal';

import SearchFilter from '../../../components/filters/search';
import CustomButton from '../../../components/buttons/customButton';
import IsActiveFilter from '../../../components/filters/isActive';
import AddButton from '../../../components/buttons/addButton';
import DataFilter from '../../../components/filters/dataFilter';
import DatePicker from '../../../components/filters/datePicker';

import AsyncDropDownFilter from '../../../components/filters/asyncDropdownFilter';

import { FcViewDetails } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, trailBalanceFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter, FiFilter } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { selectStyles } from '../../../components/dropDown/selectStyle';
import ViewModal from '../../../components/modals/viewModal';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';


function SalesByItem(props) {



  const { api, userData, categoryOptions, yearId, companyId, defaultCurrency, allUserOptions,
    customerAccountOptions, loadCustomerAccountOptions,
    mainCurrency, refData, loadProductOptions, productOptions, branchOptions, contentLanguages } = useContext(DataContext);



  const table = 'salesByItem';
  const title = 'Sales By Item';

  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const dataArray = ['branch', 'category', 'product', 'user', 'customerAccount']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', companyId, yearId, fromDate: today, toDate: today, isGrouped: false });



  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showCartModal, setShowCartModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);


  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e);
    }
    setShowViewModal(!showViewModal);
  }

  const cartModal = (e) => {
    if (!showCartModal) {
      setIdRow(e);
    }
    setShowCartModal(!showCartModal);
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const openModal = (e) => {
    if (!showModal && e) {
      setIdRow(e);
    }
    else {
      setIdRow(null);
    }
    setShowModal(!showModal);
  }



  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data) => {
    const transformedData = data.map(item => {
      const transaction = item.transaction?.journalVoucher || {};
      const product = item.product || {};

      return {
        JvId: transaction.id || '',
        Type: transaction.type || '',
        Account: transaction.account?.english || '',
        Id: item.productId || '',
        Barcode: product.barcode || '',
        Name: product.name || '',
        Quantity: item.netQuantity || 0,
        Price: item.totalPrice || 0,
        Cost: item.totalCost || 0,
        Profit: item.profit || 0,
      };
    });

    return { transformedData };
  };


  const accountIdView = (id, record) => {
    if (record.parentId) {
      return <>{record.parent?.accountId + '.' + record.accountId}</>
    } else {
      return <>{record.accountId}</>
    }
  }

  const isUsingMainCurrency = defaultCurrency.id == mainCurrency.id ? true : false;

  const newColumnDefs = useMemo(() => [
    { title: contentLanguages.JvId, dataIndex: 'transaction', render: (transaction) => transaction?.journalVoucher?.id },
    { title: contentLanguages.Type, dataIndex: 'transaction', render: (transaction) => transaction?.journalVoucher?.type },
    { title: contentLanguages.Account, dataIndex: 'transaction', render: (transaction) => transaction?.journalVoucher?.account?.english },
    { title: contentLanguages.ID, dataIndex: 'productId', width: '10%' },
    { title: contentLanguages.barcode, dataIndex: 'product', render: (product) => product.barcode },
    { title: contentLanguages.Name, dataIndex: 'product', render: (product) => product.name },
    { title: contentLanguages.Quantity, dataIndex: 'netQuantity', render: numberFormatter, sorter: (a, b) => a.age - b.age },
    { title: contentLanguages.Price, dataIndex: 'totalPrice', render: numberFormatter, sorter: (a, b) => a.age - b.age },
    { title: contentLanguages.Cost, dataIndex: 'totalCost', render: numberFormatter, sorter: (a, b) => a.age - b.age },
    { title: contentLanguages.Profit, dataIndex: 'profit', render: numberFormatter, sorter: (a, b) => a.age - b.age },
    {
      title: contentLanguages.View,
      width: '8%',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <FcViewDetails size={20} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal(record)} />
        </div>
      ),
    }
  ], []);


  const tableFooter = useMemo(() => [
    <div style={{ textAlign: 'center', paddingRight: '120px' }}>
      <Tag color={'#2c5d6f'} style={{ fontSize: '15px' }}>
        <div style={{ padding: '2px' }}>
          Total:  {numberFormatter(data?.summary?.totalPrice)}
        </div>
      </Tag>
      <Tag color={'#fe4e51'} style={{ fontSize: '15px' }}>
        <div style={{ padding: '2px' }}>
          Cost: {numberFormatter(data?.summary?.totalCost)}
        </div>
      </Tag>
      <Tag color={'#388e3c'} style={{ fontSize: '15px' }}>
        <div style={{ padding: '2px' }}>
          Profit: {numberFormatter(data?.summary?.totalProfit)}
        </div>
      </Tag>
    </div>
  ]);



  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  }

  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div>

          <Row className='g-2 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={3}>
              <DatePicker setFilter={setFilter} filter={filter} />
            </Col>

            <Col md={5}>
              <Button onClick={refreshTableFunction} style={{ backgroundColor: '#22566a' }}>
                <FiFilter size={15} color='white' />
              </Button>
            </Col>


            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
            </Col>

          </Row>


          <Row className='g-2 mb-3'>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={categoryOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select Category...'}
                value={categoryOptions?.find(option => option.value === filter.categoryId)}
                onChange={(e) => handleSelectChange(e, 'categoryId')}
              />
            </Col>


            <Col md={2}>
              <AsyncSelect
                styles={selectStyles}
                isClearable={true}
                cacheOptions
                defaultOptions
                loadOptions={loadProductOptions}
                isSearchable
                placeholder={'Select Product...'}
                value={productOptions?.find(option => option.value === filter.productId)}
                onChange={(e) => handleSelectChange(e, 'productId')}
              />
            </Col>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={allUserOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select User...'}
                value={allUserOptions?.find(option => option.value === filter.userId)}
                onChange={(e) => handleSelectChange(e, 'userId')}
              />
            </Col>


            <Col md={2}>
              <AsyncSelect
                styles={selectStyles}
                isClearable={true}
                cacheOptions
                defaultOptions
                loadOptions={loadCustomerAccountOptions}
                isSearchable
                placeholder={'Select Customer...'}
                value={customerAccountOptions?.find(option => option.value === filter.accountId)}
                onChange={(e) => handleSelectChange(e, 'accountId')}
              />
            </Col>


            <Col md={2}>
              <Select
                styles={selectStyles}
                options={branchOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select Branch...'}
                value={branchOptions?.find(option => option.value === filter.branchId)}
                onChange={(e) => handleSelectChange(e, 'branchId')}
              />
            </Col>

          </Row>





          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={newColumnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selection={true}
            height={true}
          />


          <ViewModal
            showModal={showViewModal}
            toggleModal={viewModal}
            journalVoucherId={idRow?.transaction?.journalVoucher?.id}
          />





        </div>
      }


    </div>
  )
}

export default SalesByItem;
